import { getApiAccessToken } from '../authConfig';

const axios = require('axios');

export async function getAxiosrequest(url){
    const accessToken = await getApiAccessToken();
    return axios.get(url, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    });
}

export async function getAPI(url) {
    const accessToken = await getApiAccessToken();
    return axios.get(url, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    }).then((response) => {
        if (response.status !== 200) {
            console.error(response.statusText);
            return null;
        } else {
            return response;
        }
    })
    .catch((error) => {
        console.error(error);
    });
}

export async function deleteAPI(url) {
    const accessToken = await getApiAccessToken();
    return axios.delete(url, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    }).then((response) => {
        if (response.status !== 200) {
            console.error(response.statusText);
            return response.status;
        } else {
            return response;
        }
    })
    .catch((error) => {
        console.error(error);
    });
}


export async function downloadAPI(url) {
    const accessToken = await getApiAccessToken();
    return axios.get(url, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        },
        responseType: 'arraybuffer'
    }).then((response) => {
        if (response.status !== 200) {
            return response.status;
        } else {
            return response;
        }
    })
    .catch((error) => {
        console.error(error);
    });
}

export async function postAPI(url, json) {
    const accessToken = await getApiAccessToken();
    return axios.post(url, json, {
        headers: { Authorization: 'Bearer ' + accessToken, 'Content-Type': 'application/json', 'accept': '*/*'}
    }).then((response) => {
        if (response.status !== 200) {
            console.error(response.statusText);
            return response.status;
        } else { return response; }
    })
}



export async function postFileAPI(url, file) {
    const accessToken = await getApiAccessToken();
    const formData = new FormData();

    // Update the formData object
    formData.append("formFile",file);

    return axios.post(url, formData, {
        headers:
        {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'multipart/form-data',
            'accept': '*/*'}
    }).then((response) => {
        if (response.status !== 200) {
            console.error(response.statusText);
            return response.status;
        } else { return response; }
    })
}


export async function postMultipartAPI(url, formData) {
    const accessToken = await getApiAccessToken();
    return axios.post(url, formData, {
        headers:
        {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'multipart/form-data',
            'accept': '*/*'}
    }).then((response) => {
        if (response.status !== 200) {
            console.error(response.statusText);
            return response.status;
        } else { return response; }
    })
}
